import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const NavigationIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 20),
    ...svgProps,
    viewBox: "0 0 24.211 20",
    fill: color,
    children: [/*#__PURE__*/jsx("rect", {
      width: "24.211",
      height: "2.1",
      rx: "1.05"
    }), /*#__PURE__*/jsx("rect", {
      width: "24.211",
      height: "2.1",
      y: "8.95",
      rx: "1.05"
    }), /*#__PURE__*/jsx("rect", {
      width: "24.211",
      height: "2.1",
      y: "17.9",
      rx: "1.05"
    })]
  });
};

export { NavigationIcon };
//# sourceMappingURL=navigation.js.map
